import Vue from 'vue';
import ServiceWorkerMixin from '@/mixins/ServiceWorkerMixin';
export default Vue.extend({
  name: 'Home',
  mixins: [ServiceWorkerMixin],
  computed: {
    isReady() {
      // Note: we also need to wait till the client is allowed to send messages.
      return this.$store.state.serviceWorkerReady && this.$store.state.clientMessageAllowed;
    },

    greeting() {
      return this.$store.state.greeting;
    }

  },
  methods: {
    getGreeting() {
      console.log('[Home] ++++ getGreeting()');
      this.$_ServiceWorkerMixin_sendMessage('GET_GREETING');
    }

  },
  watch: {
    isReady(newValue) {
      if (newValue === true) {
        this.getGreeting();
      }
    }

  }
});